import { Provider } from "react-redux";
import { useRoutes } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { MatxTheme } from "./components";
import { SettingsProvider } from "./contexts/SettingsContext";
import { Store } from "./redux/Store";
import { PageLayout } from "./components/PageLayout";
import routes from "./routes";
import "./styles/App.css";
import "./styles/Font.css";

const App = ({ instance }) => {
  const content = useRoutes(routes);

  return (
    <Provider store={Store}>
      <SettingsProvider>
        <MatxTheme>
          <MsalProvider instance={instance}>
            <PageLayout>{content}</PageLayout>
          </MsalProvider>
        </MatxTheme>
      </SettingsProvider>
    </Provider>
  );
};

export default App;
